import React from 'react';
import { Navigate } from 'react-router';
import moment from 'moment-jalaali';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import TaskDetailModal from './TaskDetailModal';
import NewTaskModal from './NewTaskModal';
import './CalendarView.css';

moment.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
moment.locale('fa');

export default class CalendarView extends Base {
    constructor(props) {
        super(props);
        const today = moment();
        const startOfWeek = moment(today).weekday(0).startOf('day'); // شنبه
        this.state = {
            loading: true,
            lockScreen: 0,
            events: [],
            data: null,
            currentUser: null,
            selectedTaskId: null,
            showTaskModal: false,
            showNewTaskModal: false,
            newTaskStart: null,
            newTaskEnd: null,
            showColorHelp: false,
            currentMonth: moment().startOf('jMonth'),
            currentWeek: startOfWeek,     // شنبه هفته جاری
            currentDay: moment().startOf('day'),
            view: 'month',
            holidays:[]
        };
    }

    componentDidMount() {
        this.fetchEvents();
        this.fetchHolidays();
    }

    fetchEvents() {
        this.setState({ loading: true });
        this.httpPost('api/v1/calendar/events', {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const events = data.events.map(evt => ({
                        id: evt.id,
                        title: evt.title,
                        start: new Date(evt.start),
                        end: new Date(evt.end),
                        allDay: evt.allDay,
                        type: evt.type,
                        color: evt.color,
                    }));
                    this.setState({
                        events,
                        loading: false,
                        data,
                        currentUser: data.global.user,
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    goToPreviousMonth = () => this.setState(prev => ({
        currentMonth: moment(prev.currentMonth).subtract(1, 'jMonth').startOf('jMonth'),
    }));
    goToNextMonth = () => this.setState(prev => ({
        currentMonth: moment(prev.currentMonth).add(1, 'jMonth').startOf('jMonth'),
    }));
    goToPreviousWeek = () => this.setState(prev => ({
        currentWeek: moment(prev.currentWeek).subtract(7, 'day'),
    }));
    goToNextWeek = () => this.setState(prev => ({
        currentWeek: moment(prev.currentWeek).add(7, 'day'),
    }));
    goToPreviousDay = () => this.setState(prev => ({
        currentDay: moment(prev.currentDay).subtract(1, 'day'),
    }));
    goToNextDay = () => this.setState(prev => ({
        currentDay: moment(prev.currentDay).add(1, 'day'),
    }));


    handleEventClick = (event, e) => {
        e.stopPropagation();
        if (event.type === 'task') {
            this.setState({ selectedTaskId: event.id, showTaskModal: true });
        } else if (event.type === 'payment') {
            this.showErorrMessage('جزئیات پرداخت به‌زودی اضافه می‌شود');
        }
    };

    handleDayClick = (day) => {
        this.setState({
            showNewTaskModal: true,
            newTaskStart: day.clone().startOf('day').toISOString(),
            newTaskEnd: day.clone().endOf('day').toISOString(),
        });
    };

    handleNewTaskSaved = () => {
        this.setState({ showNewTaskModal: false });
        this.fetchEvents();
    };

    fetchHolidays = () => {
        const currentYear = this.state.currentMonth ? this.state.currentMonth.jYear() : moment().jYear();
        this.httpPost('api/v1/common/holidays', { year: currentYear })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ holidays: data.holidays });
                }
            });
    };
    renderMonthGrid() {
        const { currentMonth, events, holidays } = this.state;
        const year = currentMonth.jYear();
        const month = currentMonth.jMonth();
        const firstDayOfMonth = moment()
            .jYear(year)
            .jMonth(month)
            .jDate(1)
            .weekday();
 
        //const holidays = [
        //    // فروردین
        //    { day: 1, month: 1, title: 'عید نوروز' },
        //    { day: 2, month: 1, title: 'نوروز' },
        //    { day: 3, month: 1, title: 'نوروز' },
        //    { day: 4, month: 1, title: 'نوروز' },
        //    { day: 12, month: 1, title: 'روز جمهوری اسلامی' },
        //    { day: 13, month: 1, title: 'روز طبیعت (سیزده بدر)' },
        //    { day: 25, month: 1, title: 'شهادت امام جعفر صادق (ع)' },

        //    // اردیبهشت (تعطیلات قمری خاصی در این ماه برای ۱۴۰۵ نیست)

        //    // خرداد
        //    { day: 6, month: 3, title: 'عید قربان (تقریبی)' },       
        //    { day: 14, month: 3, title: 'رحلت حضرت امام خمینی/عید سعید غدیر خم' },      
        //    { day: 15, month: 3, title: 'قیام ۱۵ خرداد' },             

        //    // تیر
        //    { day: 3, month: 4, title: 'تاسوعای حسینی (تقریبی)' },   
        //    { day: 4, month: 4, title: 'عاشورای حسینی (تقریبی)' },    

        //    // مرداد
        //    { day: 13, month: 5, title: 'اربعین حسینی (تقریبی)' },      
        //    { day: 21, month: 5, title: 'رحلت پیامبر' },
        //    { day: 22, month: 5, title: 'شهادت امام رضا' }, 

        //    // شهریور
        //    { day: 8, month: 6, title: 'میلاد رسول اکرم و امام جعفر صادق (ع)' }, 
        //        //دی ماه
        //    { day: 2, month: 10, title: 'ولادت امام علی (ع) و روز پدر' }, 
        //    { day: 16, month: 10, title: 'مبعث رسول اکرم (ص)' }, 
        //    // بهمن
        //    { day: 4, month: 11, title: 'ولادت حضرت قائم عجل الله تعالی فرجه و جشن نیمه شعبان' },    
        //    { day: 22, month: 11, title: 'پیروزی انقلاب اسلامی' },    

        //    // اسفند
        //    { day: 9, month: 12, title: 'شهادت حضرت علی' },           
        //    { day: 19, month: 12, title: 'عید سعید فطر' },      
        //    { day: 20, month: 12, title: 'تعطیل به مناسبت عید سعید فطر' },
        //    { day: 29, month: 12, title: 'روز ملی شدن صنعت نفت ایران' } 
        //];
        const daysInMonth = moment.jDaysInMonth(year, month);
        const today = moment().startOf('day');
        const weeks = [];
        let days = [];
        for (let i = 0; i < firstDayOfMonth; i++) days.push(null);
        for (let d = 1; d <= daysInMonth; d++) {
            days.push(moment().jYear(year).jMonth(month).jDate(d).startOf('day'));
            if (days.length === 7) { weeks.push(days); days = []; }
        }
        if (days.length > 0) {
            while (days.length < 7) days.push(null);
            weeks.push(days);
        }
        return (
            <div className="custom-calendar-grid">
                <div className="calendar-header">
                    {['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'].map(day => (
                        <div className="header-cell" key={day}>{day}</div>
                    ))}
                </div>
                {weeks.map((week, idx) => (
                    <div className="calendar-week" key={idx}>
                        {week.map((day, dayIdx) => {
                            if (!day) return <div className="calendar-day empty" key={dayIdx}></div>;

                            const isFriday = day.weekday() === 6; // جمعه
                            const holidayInfo = holidays.find(
                                h => h.day === day.jDate() && h.month === (day.jMonth() + 1)
                            );
                            //const isHoliday = holidayInfo || isFriday;
                            const isHoliday = holidays.find(h => h.day === day.jDate() && h.month === (day.jMonth() + 1));

                            return (
                                <div
                                    className={`calendar-day ${day.isSame(today, 'day') ? 'today' : ''} ${isHoliday ? 'holiday' : ''} ${isFriday ? 'friday' : ''}`}
                                    key={dayIdx}
                                    onClick={() => this.handleDayClick(day)}
                                >
                                    <div className="day-number">{day.jDate()}</div>
                                    {holidayInfo && <div className="holiday-title">{holidayInfo.title}</div>}
                                    {isFriday && !holidayInfo && <div className="holiday-title">جمعه</div>}
                                    <div className="day-events">
                                        {events.filter(e => moment(e.start).isSame(day, 'day')).map(e => (
                                            <div
                                                key={e.id}
                                                className="event-dot"
                                                style={{ backgroundColor: e.color }}
                                                title={e.title}
                                                onClick={(ev) => this.handleEventClick(e, ev)}
                                            >
                                                {e.title.substring(0, 10)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        );
    }


    renderWeekGrid() {
        const { currentWeek, events } = this.state;
        const startOfWeek = moment(currentWeek).startOf('week'); 
        const today = moment().startOf('day');
        const days = [];
        for (let i = 0; i < 7; i++) {
            days.push(moment(startOfWeek).add(i, 'day'));
        }
        return (
            <div className="custom-week-grid">
                <div className="week-header">
                    {days.map(day => (
                        <div className="week-header-cell" key={day.format()}>
                            <div className="week-day-name">{day.format('dddd')}</div>
                            <div className={`week-day-number ${day.isSame(today, 'day') ? 'today' : ''}`}>
                                {day.jDate()}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="week-body">
                    {days.map(day => (
                        <div
                            className="week-day-column"
                            key={day.format()}
                            onClick={() => this.handleDayClick(day)}
                        >
                            {events.filter(e => moment(e.start).isSame(day, 'day')).map(e => (
                                <div
                                    key={e.id}
                                    className="week-event"
                                    style={{ backgroundColor: e.color }}
                                    onClick={(ev) => this.handleEventClick(e, ev)}
                                >
                                    {e.title}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderDayGrid() {
        const { currentDay, events } = this.state;



        const today = moment().startOf('day');
        return (
            <div className="custom-day-grid">
                <div className="day-header">
                    <span>{currentDay.format('dddd jD jMMMM jYYYY')}</span>
                    {currentDay.isSame(today, 'day') && <span className="badge badge-primary ms-2">امروز</span>}
                </div>
                <div className="day-body" onClick={() => this.handleDayClick(currentDay)}>
                    {events.filter(e => moment(e.start).isSame(currentDay, 'day')).length === 0 ? (
                        <p className="text-muted p-4">هیچ رویدادی برای امروز وجود ندارد.</p>
                    ) : (
                        events.filter(e => moment(e.start).isSame(currentDay, 'day')).map(e => (
                            <div
                                key={e.id}
                                className="day-event"
                                style={{ borderColor: e.color }}
                                onClick={(ev) => this.handleEventClick(e, ev)}
                            >
                                <span className="event-time">{moment(e.start).format('HH:mm')}</span>
                                <span className="event-title">{e.title}</span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { loading, showColorHelp, view, currentMonth, currentWeek, currentDay } = this.state;

        const statuses = [
            { label: 'جدید', color: '#ffc107', text: 'وظیفه تازه ایجاد شده' },
            { label: 'در حال انجام', color: '#fd7e14', text: 'در دست اقدام توسط مجری' },
            { label: 'نیازمند مدارک', color: '#0d47a1', text: 'منتظر دریافت مدارک' },
            { label: 'بررسی سرپرست', color: '#e74c3c', text: 'جهت تأیید نهایی' },
            { label: 'تکمیل شده', color: '#28a745', text: 'کار پایان یافته است' },
        ];

        let contents = loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">تقویم</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <button
                                            className="btn btn-icon btn-light"
                                            onClick={() => this.setState({ showColorHelp: !showColorHelp })}
                                            title="راهنمای رنگ‌ها"
                                        >
                                            <em className="icon ni ni-info"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {showColorHelp && (
                                <div className="card card-bordered mb-3">
                                    <div className="card-inner">
                                        <h5 className="card-title">راهنمای رنگ‌ها</h5>
                                        <div className="row g-3">
                                            {statuses.map((st, idx) => (
                                                <div key={idx} className="col-sm-6 col-lg-4">
                                                    <div className="d-flex align-items-center">
                                                        <span style={{
                                                            backgroundColor: st.color,
                                                            width: '20px', height: '20px',
                                                            borderRadius: '4px',
                                                            display: 'inline-block',
                                                            marginLeft: '8px',
                                                        }} />
                                                        <div>
                                                            <strong>{st.label}</strong>
                                                            <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>{st.text}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="card card-bordered mb-2">
                                <div className="card-inner d-flex justify-content-between align-items-center">
                                    <div className="btn-group">
                                        <button
                                            className={`btn btn-sm ${view === 'month' ? 'btn-primary' : 'btn-light'}`}
                                            onClick={() => this.setState({ view: 'month' })}
                                        >ماه</button>
                                        <button
                                            className={`btn btn-sm ${view === 'week' ? 'btn-primary' : 'btn-light'}`}
                                            onClick={() => this.setState({ view: 'week' })}
                                        >هفته</button>
                                        <button
                                            className={`btn btn-sm ${view === 'day' ? 'btn-primary' : 'btn-light'}`}
                                            onClick={() => this.setState({ view: 'day' })}
                                        >روز</button>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                        <button className="btn btn-sm btn-primary" onClick={
                                            view === 'month' ? this.goToPreviousMonth :
                                                view === 'week' ? this.goToPreviousWeek : this.goToPreviousDay
                                        }>قبلی</button>
                                        <h4 className="m-0">
                                            {view === 'month' ? currentMonth.format('jMMMM jYYYY') :
                                                view === 'week' ? `هفته ${currentWeek.format('jD jMMMM')}` :
                                                    currentDay.format('jD jMMMM jYYYY')}
                                        </h4>
                                        <button className="btn btn-sm btn-primary" onClick={
                                            view === 'month' ? this.goToNextMonth :
                                                view === 'week' ? this.goToNextWeek : this.goToNextDay
                                        }>بعدی</button>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-bordered">
                                <div className="card-inner p-0" style={{ minHeight: '60vh' }}>
                                    {loading ? this.renderLoading() :
                                        view === 'month' ? this.renderMonthGrid() :
                                            view === 'week' ? this.renderWeekGrid() :
                                                this.renderDayGrid()
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <Footer />
        ];

        return (
            <>
                {contents}
                {this.state.showTaskModal && (
                    <TaskDetailModal
                        show={this.state.showTaskModal}
                        taskId={this.state.selectedTaskId}
                        onClose={() => this.setState({ showTaskModal: false, selectedTaskId: null })}
                        currentUser={this.state.currentUser}
                    />
                )}
                {this.state.showNewTaskModal && (
                    <NewTaskModal
                        show={this.state.showNewTaskModal}
                        start={this.state.newTaskStart}
                        end={this.state.newTaskEnd}
                        onClose={() => this.setState({ showNewTaskModal: false })}
                        onSaved={this.handleNewTaskSaved}
                    />
                )}
            </>
        );
    }
}